import Otp from "./otp.page";

export default Otp;
